export default {
  LIST_SUBFOLDER: 'listSubfolder',
  UPSERT_ENTRY_LIST: 'upsertEntryList',
  GET_ENTRY_DATA: 'getEntryData',
  SEARCH_BY_TERM: 'searchByTerm',
  GET_ENTRY_PARENTS_IDS: 'getEntryParentsIds',
  CHECK_COPY_MOVE_POSSIBILITY: 'checkCopyMovePossibility',
  CHECK_ENTRY_NAME_EXISTS: 'checkEntryNameExists',
  HANDLE_LOCK_MESSAGE: 'handleLockMessage'
}
